import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../components/funcionales/titder';

const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.codigoPaquete}</td>
      <td className=''>{elemento.descrPaquete}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const HomePaq2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a015001 = autorizacUA.findIndex( autorizac => autorizac === "015001" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Paquetes" btnNuevo={a015001!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '30%'}}>Código</th>
                <th className='' style={{width: '70%'}}>Descripción</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>

        {/* <Lista list={list} styles={styles} handleClickidLista={handleClickidLista}/> */}
      </List> 
    </div>
  )
};

export default HomePaq2
